module.exports = __webpack_public_path__ + "static/media/select3.5ecf8d7e.jpg";